import { render } from "./JitsiIframe.vue?vue&type=template&id=01bc81f6&ts=true"
import script from "./JitsiIframe.vue?vue&type=script&lang=ts"
export * from "./JitsiIframe.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__